import { ObjectSearchData } from '@pages/shared/models/object.types';
import { latinizeStr } from '@bazis/utils';
import moment from 'moment/moment';
import momentTz from 'moment-timezone';

export const searchInItem = (
    textParts: string[],
    searchData: ObjectSearchData,
    optional = true,
    allFound = true,
): boolean => {
    const foundParts = textParts.filter(
        (part) =>
            searchData.strict.has(part) ||
            searchData.partial.includes(part) ||
            (optional && searchData.optionalPartial.includes(part)) ||
            (searchData.latinize &&
                (searchData.latinize.includes(part) ||
                    searchData.latinize.toUpperCase().includes(latinizeStr(part.toUpperCase())))),
    );
    return allFound ? foundParts.length === textParts.length : foundParts.length > 0;
};

export const daysDiffCalculation = (start, end, timezone = null) => {
    if (!start || !end) return 0;
    const momentEnd = moment.utc(end);
    const momentStart = moment.utc(start);
    if (!timezone) {
        return momentEnd
            .local()
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0)
            .diff(momentStart.local().hours(0).minutes(0).seconds(0).milliseconds(0), 'days');
    }

    return momentTz(momentEnd)
        .tz(timezone)
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
        .diff(
            momentTz(momentStart).tz(timezone).hours(0).minutes(0).seconds(0).milliseconds(0),
            'days',
        );
};

export const getStand = () => {
    const host = new URL(window.location.href).hostname.toLowerCase();

    if (host === 'slp.big3.ru') {
        return 'master';
    }

    if (host.indexOf('test') > -1) {
        return 'test';
    }

    if (host.indexOf('demo') > -1) {
        return 'preprod';
    }
    return 'dev';
};

export const getClosestLink = (currentUrl, baseLink) => {
    const arr = currentUrl.split('/');

    let removeNumbers = arr[arr.length - 1] === 'edit' ? 2 : 1;

    if (currentUrl.indexOf(baseLink) === -1) {
        removeNumbers++;
    }

    arr.splice(-removeNumbers, removeNumbers);

    return `/${arr.join('/')}`;
};
